import { Link } from 'react-router-dom'

export function Landing() {
  return (
    <div className="min-h-[100dvh] flex flex-col bg-gradient-to-br from-stone-900 via-stone-900 to-amber-950">
      {/* Decorative background blobs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-amber-500/10 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl" />
      </div>

      <div className="relative flex flex-col flex-1 items-center justify-between px-6 py-12 max-w-lg mx-auto w-full">
        {/* Top section */}
        <div className="flex-1 flex flex-col items-center justify-center text-center gap-8">
          {/* Logo / Icon */}
          <div className="w-24 h-24 rounded-3xl bg-amber-500 flex items-center justify-center shadow-2xl shadow-amber-500/30">
            <span className="text-5xl" role="img" aria-label="beacon">🔆</span>
          </div>

          {/* App name */}
          <div className="space-y-3">
            <h1 className="text-5xl font-bold text-white tracking-tight">
              The Beacon
            </h1>
            <p className="text-xl text-amber-300 font-medium">
              Stay loosely but meaningfully connected
            </p>
          </div>

          {/* Feature description */}
          <p className="text-stone-400 text-base leading-relaxed max-w-xs">
            A gentle way to check in with the people who matter — no pressure, no noise, just a warm signal that says "I'm here."
          </p>

          {/* Feature pills */}
          <div className="flex flex-wrap justify-center gap-2">
            {[
              '😊 Share your status',
              '👥 Your circle, your rules',
              '📞 Easy check-ins',
              '🔔 No spam',
            ].map(feature => (
              <span
                key={feature}
                className="px-3 py-1.5 bg-white/10 backdrop-blur text-stone-300 text-sm rounded-full border border-white/10"
              >
                {feature}
              </span>
            ))}
          </div>

          {/* Learn more link */}
          <Link
            to="/about"
            className="text-stone-500 hover:text-amber-400 text-sm transition-colors"
          >
            Learn our story →
          </Link>
        </div>

        {/* CTA section */}
        <div className="w-full space-y-4 mt-12">
          <Link
            to="/auth?mode=signup"
            className="block w-full text-center btn-primary text-base font-bold py-4 shadow-lg shadow-amber-500/30"
          >
            Get Started — It's Free
          </Link>
          <Link
            to="/auth?mode=login"
            className="block w-full text-center py-4 text-stone-400 hover:text-stone-200 transition-colors text-sm font-medium"
          >
            Already have an account? Sign in
          </Link>
        </div>

        {/* Footer */}
        <p className="mt-6 text-stone-600 text-xs text-center">
          jointhebeacon.com · Built with care
        </p>
      </div>
    </div>
  )
}

export default Landing
